<template>

    <div  v-wechat-title="$route.meta.title='报名参与活动'">
        <div :style="background"></div>
        <van-image
          :width="width"
          :height="height"
          :src="info.img"
        />
        <div class="reg"  >
         <!--  <h2 class="title">{{info.title}}</h2> -->
         
          <van-cell-group class="group">
             <label class="fields">姓名</label>  
            <van-field  class="field" v-model="username"
              clearable
              maxlength="20"
              placeholder="请输入姓名"
            />
          </van-cell-group>
          <!-- <label class="fields">手机</label>  
          <van-cell-group class="group">
            <van-field class="field" v-model="phone"
              clearable
              maxlength="20"
              placeholder="请输入手机"
            />
          </van-cell-group>  -->
          
          <van-cell-group class="group">
             <label class="fields">所在城市/区域</label>
            <van-field @click="onSelAddr"  class="area" v-model="province"
              readonly
              input-align="right"
              label-align="right"
              placeholder="省"
              :right-icon="require('../assets/images/arrow.png')"
              
            />
             <van-field @click="onSelAddr" class="area" v-model="city"
              readonly
             label-align="right"
             input-align="right"
              placeholder="市"
              :right-icon="require('../assets/images/arrow.png')"
             
            />
             <van-field @click="onSelAddr" class="area" v-model="area"
              readonly
              label-align="right"
              input-align="right"
              placeholder="区"
              :right-icon="require('../assets/images/arrow.png')"
              
            />
           
          </van-cell-group> 

           <van-cell-group v-for="(item,index) in field" :key="'field'+index" class="group">
            <label class="fields">{{item.name}}</label>

            <van-field v-if="item.type=='input'" class="field" v-model="other[index].content"
              clearable
            />
            <van-radio-group v-else-if="item.type=='radio'" v-model="other[index].content">
              <van-radio  v-for="(option) in item.check" :name="option">{{option}}
               <img style="width: 1rem;" 
                slot="icon"
                slot-scope="props"
                :src="props.checked ? activeIcon : inactiveIcon"
              >  
            </van-radio>
            </van-radio-group>
            <van-checkbox-group v-else-if="item.type=='checkbox'" v-model="other[index].content">
              <van-checkbox v-for="(checkes) in item.check" :name="checkes">{{checkes}}
              <img style="width: 1rem;"
                  slot="icon"
                  slot-scope="props"
                  :src="props.checked ? activeIcon : inactiveIcon"
                >
              </van-checkbox>
            </van-checkbox-group>
          </van-cell-group>
           <div class="box">
              <van-button @click="submit" :disabled='disabled' :loading="loading" :class="button" >报名</van-button>
          </div>  
        
       </div> 
         <van-popup v-model="show" position="bottom">
                <van-area :area-list="areaList" @confirm="onAddrConfirm" @cancel="onAddrCancel"  title="省市"/>
        </van-popup> 
       <!-- <van-popup v-model="picker" position="bottom">
          <van-datetime-picker 
          v-model="push_time"
          type="time"
          :min-hour="0"
          :max-hour="23"
          @confirm="confirm"
          @cancel="cancel"
          @change="changepicker"
          :filter="filter"
        />
       </van-popup> -->
       <van-popup v-if="isSubscribe==1" class="popup-msg" :close-on-click-overlay="false" v-model="popupShow">
        <div style="margin-top: 3rem">
           <van-image
              width="8rem"
              :src="require('../assets/images/success_aplay.png')"
            />
          </div>
          <label style="color:#ffc425;font-size:1.2rem;display:block;margin: 1rem;">报名成功!</label>
           <label style="font-weight:600;font-size:.8rem;display:block;margin: 1rem;margin-bottom: 2rem">感谢您对莱美的支持，您将从今天开始每日收到莱美服务号推送的训练视频，敬请关注。</label>
          <van-button @click="close"   class="close" >{{buttonMsg}}</van-button> 
       </van-popup>
       <van-popup v-else class="van-popup" :close-on-click-overlay="false" v-model="popupShow">
             <div class="is-subscribe" >
                <div class="text">
                   报名成功！<br/>
                   您还不是莱美官方服务号的粉丝，无法收到订阅提醒。请扫描下方二维码，或者微信搜索 <span>"莱美爱好者"</span>，关注后获取接收订阅通知~
                </div>
                <van-image
                  width="10rem"
                  :src="require('../assets/images/qcode.jpg')"
                />
                 <van-button @click="close"   class="close1" >{{buttonMsg}}</van-button> 
             </div> 
           </van-popup>
    </div>
</template>

<script>
import { getActivitinfo,userApply} from '@/api/api.js'
import { parseTime } from '@/utils/utils.js'
import { Area,RadioGroup, Radio ,Checkbox, CheckboxGroup} from 'vant';
import areaList from '../assets/js/area.js';
export default {
   components: {
       [Area.name]:Area,
       [RadioGroup.name]:RadioGroup,
       [Radio.name]:Radio,
       [CheckboxGroup.name]:CheckboxGroup,
       [Checkbox.name]:Checkbox,
    },

    data(){
        return{
            activeIcon: require('../assets/images/radio1.png'),
            inactiveIcon: require('../assets/images/radio.png'),
            background: {
              backgroundImage:'url(' + require('../assets/images/bg.jpg') + ')',
              backgroundRepeat:"no-repeat",
              backgroundSize:"100% 100%",
              width: "100%",
              height: "100%",
              position:'fixed',
              zIndex: -10,
              top:0
             },
             loading:false,
             checked:true,
             picker:false,
             show:false,
             phone:'',
             areaList:Object,
             provincelist:'',
             info:'',
             field:[],
             id:0,
             username:"",
             push_time:'09:00',
             province:'',
             city:'',
             area:'',
             other:[],
             width:'320',
             height:"180",
             popupShow:false,
             isSubscribe:0,
             button:'button',
             disabled:false,
             buttonMsg:'',
             miniprogram:false,
             source:''
            
        }
    },
     computed: {
      
        
    },
    created(){
        
    },
    updated() {
         
    },
     mounted () {
       this.getParams();
       this.getinfo();
        window.screenWidth = document.body.clientWidth
         this.width = window.screenWidth;//设置视频长宽比
         this.height = this.width*(9/16);
         //判断是在小程序中
         let _this = this;
        wx.miniProgram.getEnv(function(res) {
          console.log(res.miniprogram) // true
          if(res.miniprogram){
              _this.miniprogram = true;  
              _this.buttonMsg = '我知道了,返回小程序';
          }else{
              _this.buttonMsg = "我知道了,返回微信";
          }
        })
    },
    methods:{
         getinfo(){
          // 异步更新数据
                let parame = {id:this.id};
                getActivitinfo(parame).then((res)=>{
                    if(res.code==200){
                      this.info = res.result.list;
                      this.field = res.result.field;
                      if(this.field&&this.field.length>0){
                          for(let i in this.field){
                             let arr = {};
                             arr.name = this.field[i].name
                             if(this.field[i].type=="checkbox"){
                                arr.content = []
                             }else{
                                arr.content = ""
                             }
                             this.other.push(arr)
                             console.log(this.other)
                          } 
                      }
                      if(res.result.is_apply==1){
                          this.popupShow = true;
                          this.isSubscribe = res.result.isSubscribe
                      }
                      if(res.result.list['status']==0){
                        this.button = 'button1';
                        this.disabled = true;  
                        this.$toast('活动已结束')
                      }
                       if(res.result.list['status']==2){
                        this.button = 'button1';
                        this.disabled = true;  
                        this.$toast('活动未开始')
                      }
                    } 
                   //Toast('提示内容') 
                }),(err)=>{
                    console.log(err);
                }
         },
          getParams() {
            this.id = this.$route.query.id;
            this.source = this.$route.query.source;
            
        },
        //返回上一页
        onClickLeft(){
            this.$router.go(-1)
        },
        confirm(){
            if(this.pickertime){
              this.push_time = this.pickertime
            }
            this.picker = false;
        },
        cancel(){
          this.picker = false;
        },
        changepicker(e){
            let time = e.getValues();
            console.log(time);
            if(time){
              this.pickertime = `${time[0]}:${time[1]}`
              
            }
             
        },
         filter(type, options) {
            if (type === 'minute') {
              return options.filter(option => option % 5 === 0)
            }

            return options;
        },
        checkitPicker(){
          window.scrollTo(0, 0);
          this.picker = true;
        },
         onSelAddr(){   //选择地区
            window.scrollTo(0, 0);
            this.show = true; 
            this.areaList = areaList;
        },
        onAddrConfirm(val){  //确定选择
            this.show = false;     
            this.province  = val[0].name;
            this.city =  val[1].name ;
            this.area =  val[2].name ;
            this.provincelist = this.province+"/"+this.city+"/"+this.area    
        },
        onAddrCancel(){  //取消选择
            this.show = false;
        },
        //提交
        submit(){
          
          let data = {"aid":this.id,"username":this.username,"push_time":this.push_time,"source":this.source,
          "province":this.province,"city":this.city,"area":this.area,"other":this.other};
          if(!this.checked){
              return false;
          }
          
          if(this.username==''){
              this.$toast("请输入姓名")
              return false;
          }
         
          if(this.province==''){
              this.$toast("请选择城市/区域")
              return false;
          }
          this.loading = true;
           userApply(data).then((res)=>{
                    if(res.code==200){
                      //this.$toast.success("报名成功")
                      this.popupShow = true;
                      this.isSubscribe = res.result.isSubscribe
                    }else{
                     
                        this.$toast(res.message)
                    } 
                    this.loading = false;
                   //Toast('提示内容')
                  //console.log(this.list);  
                }),(err)=>{
                    this.$toast("报名失败")
                }
        },
        close(){
           if(this.miniprogram){
             
              wx.miniProgram.reLaunch({
                url: '/pages/homePage/homePage'
              })
           }else{
             WeixinJSBridge.call('closeWindow');
           }
            
        },
        

    },
    watch: {
        
    }

}
</script>
<style type="text/css">
  .van-checkbox-group{
    border-bottom: 1px solid #fff;
    width:90%;
    margin: auto;
    text-align: left;
  }
  .van-checkbox__icon{
     display: inline-block;
     font-size: 15px;
  }
  .van-checkbox__label{
    color:#fff;
  }
  .van-checkbox{
    display: inline-block;
    text-align: left;
    margin-right:1rem;
  }
  .van-radio-group{
    border-bottom: 1px solid #fff;
    width:90%;
    margin: auto;
    text-align: left;
  }
  .van-radio{
    display: inline-block;
    text-align: left;
    margin-right:1rem;
  }
  .van-radio__icon{
     display: inline-block;
     font-size: 15px;
     
  }
.van-radio__label{
    color:#fff;
  }
  .van-field__control {
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 0;
    color: #fff;
    text-align: left;
    background-color: transparent;
    border: 0;
    resize: none;
}
    

.area input{
  text-align: center;
}
.van-divider,.van-divider--hairline{
    width: 90%;
    margin: auto;
    border-color: #fff;
    border-width: .1px;
}
.van-cell:not(:last-child)::after {
    position: absolute;
    box-sizing: border-box;
    content: ' ';
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 16px;
     border:none;
    -webkit-transform: scaleY(.5);
    transform: scaleY(.5);
}
</style>  
<style scoped>
  .van-popup{
    border-radius: .5rem;
  }
  .is-subscribe{
     width:18rem;
     height:24rem;
     top:45%;
     color:#000;

  }
  .is-subscribe>.text{
    padding: 1rem;
    text-align: left;
    padding: 1rem;
    text-align: left;
    letter-spacing: .01rem;
    font-size: 0.9rem;

  }
  .close{
    margin:auto;
    color:#000;
    width: 70%;
    background-color:#ffc425;
    border: none;
    margin-bottom: 1.5rem
  }
  .close1{
    width:12rem;
    margin:auto;
    color:#000;
    background-color:#ffc425;
    border: none;
    margin-bottom: 1.5rem;
    font-weight:600;
}
  .popup-msg{
    width:80%;
    height:24rem;
    top:45%;
    border-radius: .5rem;
    color:#000;
  }
  .box{
    padding-top:4rem ;
    margin-bottom: 2rem;
    
  }
  .box .button{
    margin:auto;
    color:#000;
    width: 95%;
    background-color:#ffc425;
    border: none;
    font-weight: 600
  }
  .box .button1{
    margin:auto;
    color:#000;
    width: 95%;
    background-color:#e2e2e2;
    border: none;
    font-weight: 600
  }
.checkbox{
    font-size: .5rem;
    margin:auto;
    width: 50%;
}  
.reg{
  width:90%;
  height:100%;
  margin: auto;
  margin-top:1.5rem;
}
.reg label{
    margin-top: 1rem;
    color:#ffc425;
    text-align: left;
    display: block;
    padding-left: 1rem;
    margin-bottom: 1rem;
}
.title{
    font-size: 1.2rem;
    color: #fff;
    font-family: 微软雅黑;
    height: 1.2rem;
}
.group{
  margin-top:.5rem;
  background-color:transparent;
  zoom:1
}
.group::after{
  border: none;
}
.field{
  width:90%;
  margin: auto;
  background-color:transparent;
  border-bottom: 1px solid #fff;
  padding:0;
  color:#fff;
}
.area{
  display: inline-block;
  width:30%;
  margin: auto;
  background-color:transparent;
  border-bottom: 1px solid #fff;
  padding:0;
  color:#fff;
}
.area::after{
  clear: both;
}
.form{
  padding:.5rem;
}
.image{
  margin: .5rem auto;
  height: 10rem !important;
  opacity: 0.8;
}

</style>